import VMwareManagedServices from "./VMwareManagedServices";

export default VMwareManagedServices;
